import React from 'react';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import EventNoteIcon from '@material-ui/icons/EventNote';
import TableRow from '@material-ui/core/TableRow';

import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import Tooltip from '@material-ui/core/Tooltip';
import Pagination from '@material-ui/lab/Pagination';

import {Grid, Switch, Typography, withStyles} from "@material-ui/core";

import EditIcon from '@material-ui/icons/Edit';
import Filters from "./Filters";
import {connect} from "react-redux";
import {EnhancedTableHead} from "../../components/EnhancedTableHead";
import { getComparator, stableSort} from "../../utils/tableUtils";
import AddNew from "../../components/Popups/AddNew";
import {
    addClients, changeLabelClient, changeNameClient,
    changePlan,
    getClients,
    lockCaptcha,
    lockClients,
    removeClients
} from "../../services/clientsService";
import {MuiThemeProvider} from "material-ui";
import HttpsOutlinedIcon from '@material-ui/icons/HttpsOutlined';
import LockOpenOutlinedIcon from '@material-ui/icons/LockOpenOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import IconButton from "@material-ui/core/IconButton";
import Button from "@material-ui/core/Button";
import Select from "../../components/Select";
import ApproveRemove from "../../components/Popups/ApproveRemove";
import {getStateFromLocalStorage, setStateToLocalStorage, showFAlert} from "../../utils/functions";
import {withRouter} from "react-router-dom";
import {parseFiltersFromSearch, syncFiltersToUrl} from "../../utils/urlFilters";
import SelectPlan from "../../components/Popups/SelectPlan";
import Box from "@material-ui/core/Box";
import ChangeLabel from "../../components/Popups/ChangeLabel";
import StatPopup from "../../components/Popups/StatPopup";

const TABLE_GIRLS_FILTERS_SCHEMA = {
    page: 'number',
    rowPerPage: 'pageSize',
    id: 'string',
    site: 'string',
    state: 'string',
    type: 'string',
    name: 'string',
};

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
    },
}))(TableRow);

const styles = theme => ({
    root: {
        width: '100%',

    },
    sec: {
        color: theme.palette.secondary.main
    },
    prim: {
        color: theme.palette.primary.main
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {},
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    selectedRow: {
        '&:hover': {
            backgroundColor: theme.palette.action.hover
        }
    },
    button: {
        color: '#fff',
        marginLeft: '10px',
        marginBottom: '10px',
        width: '200px'
    },
    selectedPagin: {
        color: '#ffffff'
    },
    '@global': {
        '.MuiPaginationItem-textPrimary.Mui-selected': {
            color: '#ffffff'
        }
    },
    disabledSwitch: {

    }
});

class TableGirls extends React.Component {

    constructor(props) {
        super(props);
        let a = getStateFromLocalStorage('clients');
        if (!!a) {
            let orderBy = a.orderBy;
            if (orderBy === 'id') {
                orderBy = null;
            }
            this.state = {...a, selected: [], needToBeRemoved: [], showRemoveApprove: false, order: 'asc', orderBy, clients: []};
        } else {
            this.state = {
                showRemoveApprove: false,
                needToBeRemoved: [],

                selectPlanSite: null,
                showPlanSelect: false,
                selectedPlan: null,
                needToChangePlan: [],
                selectedPlanType: '',

                order: null,
                orderBy: null,

                page: 1,
                rowPerPage: 10,

                selected: [],

                addUsersDialogOpen: false,

                filters: {
                    id: '',
                    site: '',
                    state: '',
                    type: '',
                    name: ''
                },
                isOpenLabelPopup: false,
                labelPopupValue: null,
                labelChangeClient: null,
                isOpenNamePopup: false,
                namePopupValue: null,
                nameChangeClient: null,
                
                isStatPopupOpen: false,
                statPopupClientId: null,

                clients: [],
            }
        }

        const urlFilters = parseFiltersFromSearch(props.location.search, TABLE_GIRLS_FILTERS_SCHEMA);
        this._hasUrlFilters = Object.keys(urlFilters).length > 0;
        if (this._hasUrlFilters) {
            this.state = {
                ...this.state,
                page: urlFilters.page || this.state.page,
                rowPerPage: urlFilters.rowPerPage || this.state.rowPerPage,
                filters: {
                    id: urlFilters.id !== undefined ? urlFilters.id : this.state.filters.id,
                    site: urlFilters.site !== undefined ? urlFilters.site : this.state.filters.site,
                    state: urlFilters.state !== undefined ? urlFilters.state : this.state.filters.state,
                    type: urlFilters.type !== undefined ? urlFilters.type : this.state.filters.type,
                    name: urlFilters.name !== undefined ? urlFilters.name : this.state.filters.name,
                }
            };
        }
    }

    fetchClients = (overrides = {}) => {
        const filters = overrides.filters || this.state.filters;
        const page = overrides.page || this.state.page;
        const rowPerPage = overrides.rowPerPage || this.state.rowPerPage;
        this.props.dispatch(getClients({page, rowPerPage, filters}));
        syncFiltersToUrl(this.props.history, {...filters, page, rowPerPage});
    }

    filterBy = (value, type) => {
        const {filters} = this.state;
        const newFilters = {...filters, [type]: value};
        this.setState({filters: newFilters, page: 1})
        this.fetchClients({filters: newFilters, page: 1});
    }

    handleRequestSort = (event, property) => {
        const isAsc = this.state.orderBy === property && this.state.order === 'asc';
        this.setState({order: isAsc ? 'desc' : 'asc', orderBy: property});
    };

    setState(state, callback) {
        super.setState(state, () => setStateToLocalStorage('clients', this.state));
        setStateToLocalStorage('clients', this.state);
    }
    

    handleSelectAllClick = (event) => {
        const {clients} = this.props;
        if (event.target.checked) {
            this.setState({selected: clients.map((n) => n.id)});
            return;
        }
        this.setState({selected: []});
    };

    handleClick = (event, name) => {
        const {selected} = this.state;
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({selected: newSelected});
    };

    handleChangePage = (event, newPage) => {
        this.setState({page: newPage});
        this.fetchClients({page: newPage});
    };

    handleChangeRowsPerPage = (event) => {
        event = event === 'ВСЕ' ? event : parseInt(event, 10);
        this.setState({
            rowPerPage: event,
            page: 1
        })
        this.fetchClients({rowPerPage: event, page: 1});
    };

    removeClients = (clients, forceRemove = false) => {
        if (!forceRemove) {
            this.setState({showRemoveApprove: true, needToBeRemoved: clients})
            return;
        }
        this.props.dispatch(removeClients(clients)).then(() => this.fetchClients());
        this.setState({showRemoveApprove: false, needToBeRemoved: []});
    }

    changeLabel = () => {
        this.props.dispatch(changeLabelClient(this.state.labelChangeClient, this.state.namePopupValue, this.state.labelPopupValue)).then(() => this.fetchClients());
        this.setState({isOpenLabelPopup: false, labelChangeClient: null, labelPopupValue: null});
    }

    changeName= () => {
        this.props.dispatch(changeNameClient(this.state.nameChangeClient, this.state.namePopupValue)).then(() => this.fetchClients());
        this.setState({isOpenNamePopup: false, nameChangeClient: null, namePopupValue: null});
    }

    handleChangePlan = (clients, siteId, type, selectedPlan = null) => {
        this.setState({showPlanSelect: true, needToChangePlan: clients, selectedPlan, selectPlanSite: siteId, selectedPlanType: type})
    }

    changePlanCallback = planId => {
        this.props.dispatch(changePlan(this.state.needToChangePlan.map(el => el.id), planId)).then(() => this.fetchClients());
        this.setState({showPlanSelect: false, needToChangePlan: [], selectedPlan: null})
    }

    isSelected = (id) => this.state.selected.indexOf(id) !== -1;

    getFormattedTime = (mins) => {
        let days = Math.floor(mins / (60 * 24))
        let hours = Math.floor((mins - days * 24 * 60) / 60)
        let minutes = mins - hours * 60 - days * 24 * 60
        return (
            <TableCell align="left">
                <b style={{fontSize: '18px'}}>{days}</b> дней <b style={{fontSize: '18px'}}>{hours}</b> часов <b
                style={{fontSize: '18px'}}>{minutes}</b> минут
            </TableCell>
        )
    }

    componentDidMount() {
        if (this._hasUrlFilters) {
            this.fetchClients();
            return;
        }
        let a = getStateFromLocalStorage('clients');
        if (!!a) {
            this.setState({...a, selected: [], needToBeRemoved: [], showRemoveApprove: false});
            this.fetchClients({filters: a.filters, page: a.page, rowPerPage: a.rowPerPage});
        } else {
            this.fetchClients();
        }
    }

    render() {
        const {rowPerPage, page, order, orderBy, selected, addUsersDialogOpen} = this.state;
        const {clients, classes, sites, dispatch, pagination} = this.props;

        let clientsList = stableSort(clients, getComparator(order, orderBy))
        return (
            <div className={classes.root}>
                <Filters
                    onClickToAddNew={() => {
                        this.setState({addUsersDialogOpen: true})
                    }}
                    values={{...this.state.filters}}
                    id={this.state.filters.id}
                    site={this.state.filters.site}
                    state={this.state.filters.state}
                    type={this.state.filters.type}
                    name={this.state.filters.name}
                    reset={() => {
                        const emptyFilters = {id: '', site: '', state: '', type: '', name: ''};
                        this.setState({filters: emptyFilters, order: 'asc', orderBy: null, page: 1});
                        this.fetchClients({filters: emptyFilters, page: 1});
                    }}
                    filterBy={this.filterBy}
                />
                <Paper component={'div'} className={classes.paper}>


                    <TableContainer>
                        <Table
                            stickyHeader
                            className={classes.table}
                            aria-labelledby="tableTitle"
                            size={'small'}
                            aria-label="enhanced table"
                        >
                            <EnhancedTableHead
                                classes={classes}
                                numSelected={selected.length}
                                order={order}
                                orderBy={orderBy}
                                onSelectAllClick={this.handleSelectAllClick}
                                onRequestSort={this.handleRequestSort}
                                page={page}
                                rowCount={clientsList.length}
                            />

                            <TableBody>
                                {
                                    clientsList
                                    .map((row, index) => {
                                        const isItemSelected = this.isSelected(row.id);
                                        const labelId = `enhanced-table-checkbox-${index}`;

                                        return (

                                            <StyledTableRow
                                                hover={false}

                                                role="checkbox"
                                                aria-checked={isItemSelected}
                                                tabIndex={-1}
                                                key={row.name}
                                            >
                                                <MuiThemeProvider>
                                                    <TableCell padding="checkbox">
                                                        <Checkbox
                                                            color={'primary'}
                                                            checked={isItemSelected}
                                                            inputProps={{'aria-labelledby': labelId}}
                                                            onClick={(event) => this.handleClick(event, row.id)}
                                                        />
                                                    </TableCell>
                                                    <TableCell component="th" id={labelId} scope="row" padding="none">
                                                        {row.login}
                                                    </TableCell>
                                                    <TableCell
                                                        
                                                        align={'center'}
                                                        component="th"
                                                        id={labelId}
                                                        scope="row"
                                                        padding="none"
                                                    >
                                                        <Box style={{
                                                            border: 'solid 1px #d7caca',
                                                            borderRadius: '4px',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            padding: '10px 10px',
                                                            // background: '#fff',
                                                            justifyContent: 'space-between'
                                                        }}
                                                             onClick={() =>
                                                                 this.setState({
                                                                     labelPopupValue: row.label,
                                                                     namePopupValue: row.name,
                                                                     isOpenLabelPopup: true,
                                                                     labelChangeClient: row.id
                                                                 })}
                                                        >
                                                            <Typography component={'div'} style={{
                                                                fontSize: '12px',
                                                                textOverflow: 'ellipsis',
                                                                overflow: 'hidden',
                                                                whiteSpace: 'nowrap',
                                                                maxWidth: '70px'
                                                            }}>{row.name}</Typography>
                                                            {/*<IconButton onClick={() => {}}>*/}
                                                            <EditIcon color={'primary'}/>
                                                            {/*</IconButton>*/}
                                                        </Box>
                                                    </TableCell>
                                                    
                                                    <TableCell align="left" style={{
                                                        color: '#6495ed',
                                                        fontSize: '1rem'
                                                    }}>{row.siteName}</TableCell>
                                                    <TableCell align="left">{row.type}</TableCell>
                                                    <TableCell
                                                        align="left">
                                                        {typeof row.captcha !== 'undefined' &&
                                                   
                                                        <Tooltip title={row.captcha ? "Разрешено" : "Запрещено"}>
                                                            <Switch
                                                                checked={row.captcha}
                                                                color={"primary"}
                                                                onChange={() => dispatch(lockCaptcha([row.id], row.captcha)).then(() => this.fetchClients())}
                                                            />
                                                        </Tooltip>
                                                        }

                                                    </TableCell>
                                                    {this.getFormattedTime(row.left)}
                                                    <TableCell align="left">{(row.left > 0 || row.site.is_under_test) ?
                                                        <span className={classes.prim}><b>Активный {row.site.is_under_test ? 'Beta тест' : ''}</b></span> : <span
                                                            className={classes.sec}><b>Не активный</b></span>}</TableCell>
                                                    <TableCell align="center">{
                                                        !!row.tarif_plan ?
                                                            <Tooltip title={'Нажмите для выбора тарифного плана'}>
                                                            <Button
                                                                style={{width: '110px'}}
                                                                variant={'contained'}
                                                                color={'primary'}
                                                                size={"small"}
                                                                onClick={() => this.handleChangePlan([row], row.site_id, row.type, row.tarif_plan.id)}>
                                                                {row.tarif_plan.title}
                                                            </Button>
                                                            </Tooltip>:
                                                            <Tooltip title={'Нажмите для выбора тарифного плана'}>
                                                            <Button
                                                                style={{width: '110px'}}
                                                                onClick={() => this.handleChangePlan([row] , row.site_id, row.type)}
                                                                variant={'contained'} color={'secondary'}
                                                                size={"small"}>
                                                                Не выбрана
                                                            </Button>
                                                            </Tooltip>
                                                    }
                                                    </TableCell>
                                                    <TableCell align={"center"}>
                                                        
                                                        <Tooltip title={!row.locked ? "Разрешено" : "Запрещено"}>
                                                            <Switch
                                                                checked={!row.locked}
                                                                color={"primary"}
                                                                onChange={() => dispatch(lockClients([row.id], !row.locked)).then(() => this.fetchClients())}
                                                            />
                                                        </Tooltip>

                                                    </TableCell>
                                                    
                                                    <TableCell align="left">
                                                        <Tooltip arrow={true} title={'История расходов'}>
                                                            <IconButton
                                                                onClick={() => this.setState({isStatPopupOpen: true, statPopupClientId: row.id})}>
                                                                <EventNoteIcon color={'primary'}/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell align="left">
                                                        <Tooltip arrow={true} title={'Удалить'}>
                                                            <IconButton
                                                                onClick={() => this.removeClients([row.id])}>
                                                                <DeleteOutlineIcon color={'secondary'}/>
                                                            </IconButton>
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell align="left">{row.smt}</TableCell>
                                                </MuiThemeProvider>
                                            </StyledTableRow>

                                        );
                                    })}

                            </TableBody>

                        </Table>
                    </TableContainer>

                </Paper>
                <Grid container>
                    <Grid item xs={7} sm={7} md={7} lg={7}></Grid>
                    <Grid item xs={5} sm={5} md={5} lg={5} style={{
                        display: 'flex',
                        aligItems: 'center',
                        fontSize: '11px',
                        alignItems: 'center',
                        color: 'gray'
                    }}>
                        <Typography variant={'span'} style={{'marginRight': '10px'}}>
                            Записей на странице
                        </Typography>
                        <Select
                            value={rowPerPage}
                            type={'select'}
                            rowsPerPageOptions={[10, 25, 50, 100, 'ВСЕ']}
                            borderRadius={'20px 20px'}
                            width={'76px'}
                            onChange={this.handleChangeRowsPerPage}
                        />

                        {rowPerPage !== 'ВСЕ' && <Pagination
                            classes={{selected: classes.selectedPagin}}
                            count={pagination.lastPage || 1}
                            color="primary"
                            page={page}
                            onChange={this.handleChangePage}
                            size={'large'}/>}
                    </Grid>
                </Grid>

                {selected.length > 0 && <Grid container style={{marginTop: '20px'}}>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            startIcon={<LockOpenOutlinedIcon/>}
                            onClick={() => dispatch(lockClients(selected, false)).then(() => this.fetchClients())}
                        >
                            Разрешить автопродление
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            startIcon={<HttpsOutlinedIcon/>}
                            onClick={() => dispatch(lockClients(selected, true)).then(() => this.fetchClients())}
                        >
                            Запретить автопродление
                        </Button>
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                        {clientsList.filter(elem => typeof elem.captcha !== 'undefined' && selected.includes(elem.id)).length > 0 &&
                        <Button
                            variant="contained"
                            color="primary"
                            className={classes.button}
                            startIcon={<LockOpenOutlinedIcon/>}
                            onClick={() => dispatch(lockCaptcha(selected, false)).then(() => this.fetchClients())}
                        >
                            Разрешить<br/> капчу
                        </Button>}
                    </Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                        {clientsList.filter(elem => typeof elem.captcha !== 'undefined' && selected.includes(elem.id)).length > 0 &&
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            startIcon={<HttpsOutlinedIcon/>}
                            onClick={() => dispatch(lockCaptcha(selected, true)).then(() => this.fetchClients())}
                        >
                            Запретить<br/> капчу
                        </Button>}
                    </Grid>

                    <Grid item xs={12} sm={12} md={2} lg={2}></Grid>
                    <Grid item xs={12} sm={12} md={2} lg={2}>
                        <Button
                            variant="contained"
                            color="secondary"
                            className={classes.button}
                            startIcon={<DeleteOutlineIcon/>}
                            onClick={() => this.removeClients(selected)}
                        >
                            Удалить выделенные
                        </Button>
                    </Grid>
                </Grid>

                }
                <SelectPlan
                    discount={this.props.user.discount}
                    plans={
                    this.props.adminSites.includes(this.state.selectPlanSite)
                        ? this.props.adminTariffs
                        : (this.props.hiddenSites.includes(this.state.selectPlanSite) ? this.props.hiddenTariffs : this.props.tariffs) }
                    open={this.state.showPlanSelect}
                    selected={this.state.selectedPlan}
                    siteType={this.state.selectedPlanType}
                    user={this.state.needToChangePlan[0]}
                    onClose={() => this.setState({showPlanSelect: false, needToChangePlan: [], selectedPlan: null})}
                    onSuccess={this.changePlanCallback}
                />
                {sites.length && <AddNew
                    open={addUsersDialogOpen}
                    sites={sites}
                    onClose={() => this.setState({addUsersDialogOpen: false})}
                    onSuccessAdded={(clients, site, services) => {
                        dispatch(addClients(clients, site, services)).then(() => this.fetchClients());
                    }}
                />}
                <ApproveRemove
                    onClose={() => {
                        showFAlert('Ошибка', 'Действие отменено пользователем.', dispatch)
                        this.setState({showRemoveApprove: false})
                    }
                    }
                    onSuccess={() => {

                        this.removeClients(this.state.needToBeRemoved, true);
                    }}
                    displayedIdentifiers={clientsList.filter(el => this.state.needToBeRemoved.includes(el.id)).map(el => el.login + ' (' + el.type + ')').join(' ,')}
                    needToBeRemoved={this.state.needToBeRemoved}
                    open={this.state.showRemoveApprove}
                />
                <ChangeLabel
                    onChangeName={(text) => this.setState({namePopupValue: text})}
                    onChangeLabel={(text) => this.setState({labelPopupValue: text})}
                    valueName={this.state.namePopupValue} 
                    valueLabel={this.state.labelPopupValue} 
                    open={this.state.isOpenLabelPopup} 
                    onClose={() => this.setState({isOpenLabelPopup: false, labelPopupValue: null, namePopupValue:null})}
                    onSuccess={this.changeLabel}
                />
                <StatPopup
                    client={this.state.statPopupClientId} 
                    open={this.state.isStatPopupOpen} 
                    onClose={() => this.setState({isStatPopupOpen: false, statPopupClientId: null})}
                />
                {/*<ChangeName*/}
                {/*    onChange={(text) => this.setState({namePopupValue: text})}*/}
                {/*    value={this.state.namePopupValue} */}
                {/*    open={this.state.isOpenNamePopup} */}
                {/*    onClose={() => this.setState({isOpenNamePopup: false, namePopupValue: null})}*/}
                {/*    onSuccess={this.changeName}*/}
                {/*/>*/}
            </div>
        );
    }

}

const mapStateToProps = store => {

    return {
        clients: store.Clients.clients,
        pagination: store.Clients.clientsPagination || {},
        user: store.Auth.user,
        sites: store.Clients.sites,
        tariffs: store.Common.tariffs,
        adminTariffs: store.Common.adminTariffs,
        hiddenTariffs: store.Common.hiddenTariffs,
        adminSites: store.Common.adminSites,
        hiddenSites: store.Common.hiddenSites
    }
}

export default withRouter(connect(mapStateToProps)(withStyles(styles)(TableGirls)))